<template>
<v-container align-center>
  <v-flex xs12 sm6 offset-sm3 text-xs-center>

    <form class="row">
      <v-text-field v-model="email" label="Username" name="username" id="username" required="" :rules="[rules.required]"></v-text-field>
      <v-text-field v-model="password" label="password" name="password" type="password" id="password" required=""             :rules="[rules.required]"></v-text-field>

      <!-- <v-btn  color="primary">Login</v-btn> -->
      <el-button type="primary" @click.prevent="login()">Login</el-button>
    </form>

    <!-- snackbar -->
    <v-snackbar :timeout="timeout" :color="snackbarColor" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
      {{ snackbarText }}
      <v-btn dark flat @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
    <!-- snackbar -->
  </v-flex>
</v-container>

</div>
</template>

<script>
import $ from 'jquery';
import { mapState } from 'vuex';
import { api } from '../api.js';
import { axios, post } from 'axios';

export default {
  userName: '',
  components: {},
  data() {
    return {
      snackbar: false,
      snackbarColor: '',
      mode: '',
      timeout: 6000,
      snackbarText: "Hello, I'm a snackbar",
      output: '',
      email: '',
      password: '',
      clinic_id: '',
      rules: {
          required: value => !!value || 'Required.'
          }

    };
  },
  methods: {
    login() {
      if(!this.email || !this.password){
          this.snackbar = true;
          this.snackbarColor = 'red darken-3';
          this.snackbarText = 'Please enter username & password';
        return;
      }
      post(
        api + `/login`,{}
,        {
          auth: {
            username: this.email,
            password: this.password
        }
        }
      ).then(res => {
        if (res.data.status) {
          console.log(res.data)
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('clinic_id', JSON.stringify(res.data.doctors[0].clinic_id));
          localStorage.setItem('doctor_id', JSON.stringify(res.data.doctors[0].doctor_id));
          localStorage.setItem('doctor_name', res.data.doctors[0].doctor_name);
          localStorage.setItem('doctors', JSON.stringify(res.data.doctors));
          localStorage.setItem('profilePhoto', 'null');
          // this.$store.commit('doctorId', res.data.doctor_id);
          this.snackbar = true;
          this.snackbarColor = 'blue darken-1';
          this.snackbarText = `Welcome ${res.data.user_name}!`;
          this.$router.push('/dashboard/' + parseInt(localStorage.clinic_id) + "/" + parseInt(localStorage.doctor_id));
        } else {
          this.snackbar = true;
          this.snackbarColor = 'red darken-3';
          this.snackbarText = res.data.status;
          localStorage.setItem('profilePhoto', 'null');
        }
      });
    }
  }
};
</script>
<style scoped>
.container {
  height: 100vh;
  display: flex;
}
.row {
  padding: 0rem 10rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue